import { AppState } from '../index'

export const userState = (state: AppState) => state.userReducer
